import { DataTable } from '@/components/ui/DataTable';
import { Badge } from '@/components/ui/Badge';
import type { AdminUser } from '@/types/admin.types';
import { formatDateTime, formatRelativeTime } from '@/utils/formatters';
import { createColumnHelper } from '@tanstack/react-table';
import { useNavigate } from 'react-router-dom';

const columnHelper = createColumnHelper<AdminUser>();

const columns = [
  columnHelper.accessor('email', {
    header: 'Email',
    cell: (info) => (
      <div>
        <p className="font-medium text-neutral-900 dark:text-neutral-200">{info.getValue()}</p>
        <p className="text-xs text-neutral-500">
          {info.row.original.firstName} {info.row.original.lastName}
        </p>
      </div>
    ),
  }),
  columnHelper.accessor('role', {
    header: 'Rôle',
    cell: (info) => <Badge variant="info">{info.getValue()}</Badge>,
  }),
  columnHelper.accessor('status', {
    header: 'Statut',
    cell: (info) => {
      const v = info.getValue();
      return (
        <Badge variant={v === 'active' ? 'success' : v === 'locked' ? 'danger' : 'neutral'}>
          {v}
        </Badge>
      );
    },
  }),
  columnHelper.accessor('organisations', {
    header: 'Organisations',
    cell: (info) => (
      <span className="text-neutral-600 dark:text-neutral-400">{info.getValue()?.length ?? 0}</span>
    ),
    enableSorting: false,
  }),
  columnHelper.accessor('lastLoginAt', {
    header: 'Dernière connexion',
    cell: (info) => (
      <span className="text-neutral-500 text-xs">
        {info.getValue() ? formatRelativeTime(info.getValue()) : 'Jamais'}
      </span>
    ),
  }),
  columnHelper.accessor('createdAt', {
    header: 'Inscription',
    cell: (info) => (
      <span className="text-neutral-500 text-xs">{formatDateTime(info.getValue())}</span>
    ),
  }),
];

interface UsersTableProps {
  data: AdminUser[];
  loading?: boolean;
}

export function UsersTable({ data, loading }: UsersTableProps) {
  const navigate = useNavigate();

  return (
    <DataTable
      columns={columns}
      data={data}
      loading={loading}
      onRowClick={(row) => navigate(`/users/${row.uuid}`)}
      emptyMessage="Aucun utilisateur trouvé"
    />
  );
}
